import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../services/api.service';

export interface IDashboard {
    iniciadas: number;
    nao_iniciadas: number;
    concluidas: number;
    total: number;
}

export interface IFiltroDashboard {
    dono?: string,
    equipe?: string
    data_inicio_de?: string,
    data_inicio_ate?: string,
    data_fim_de?: string,
    data_fim_ate?: string,
    em_uso?: boolean
}

@Injectable()
export class AdmDashboardService {
    private baseUrl = `admin/dashboard`;

    constructor(protected apiService: ApiService) {}

    public getDashboard(filtro: IFiltroDashboard) {
        return this.apiService.get(this.baseUrl, filtro) as unknown as Observable<IDashboard>;
    }
}
